import Vue from 'vue';
import { errors, wx } from '@/services/indexnew';
import { wxAppInfo } from '@/config';

const jsApiList = [
	'updateAppMessageShareData',
	'updateTimelineShareData',
	'checkJsApi',
	'onMenuShareTimeline',
	'onMenuShareAppMessage',
	'onMenuShareQQ',
	'onMenuShareWeibo',
	'onMenuShareQZone',
	'hideMenuItems',
	'showMenuItems',
	'hideAllNonBaseMenuItem',
	'showAllNonBaseMenuItem',
	'translateVoice',
	'startRecord',
	'stopRecord',
	'onVoiceRecordEnd',
	'playVoice',
	'onVoicePlayEnd',
	'pauseVoice',
	'stopVoice',
	'uploadVoice',
	'downloadVoice',
	'chooseImage',
	'previewImage',
	'uploadImage',
	'downloadImage',
	'getNetworkType',
	'openLocation',
	'getLocation',
	'hideOptionMenu',
	'showOptionMenu',
	'closeWindow',
	'scanQRCode',
	'chooseWXPay',
	'openProductSpecificView',
	'addCard',
	'chooseCard',
	'openCard',
];

// 需要使用的开放标签列表
const openTagList = [
	'wx-open-launch-weapp', // 跳转小程序
	'wx-open-launch-app', // 跳转APP
	'wx-open-subscribe', // 跳转服务号订阅通知
	'wx-open-audio', // 微信上小窗音频播放
];

export const wxConfig = async () => {
	try {
		if (Vue.$wx) {
			const url = window.location.href.split('#')[0];
			Vue.$wx.error((res) => {
				console.info(res);
			});
			const id = wxAppInfo.appid;
			let wxconfig = wx.config;
			const { ok, data } = await wxconfig(id, url);
			if (ok) {
				Vue.$wx.config({
					...data.data,
					debug: false,
					// debug: process.env.NODE_ENV === 'development',
					jsApiList,
					openTagList,
				});
			}
		}
	} catch (error) {
		errors(error);
	}
};
